"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FormFieldGroupLayout = require("./FormFieldGroupLayout");
Object.keys(_FormFieldGroupLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormFieldGroupLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormFieldGroupLayout[key];
    }
  });
});